module.exports = __webpack_public_path__ + "img/xiaomi.f128d6b.png";